import Vue from 'vue';
import VueRouter from 'vue-router';
import { setLinkFavicon, searchParams, jsonParser } from '@/lib/utils';
import { Platform } from '@/enums';
import routes from './config';

Vue.use(VueRouter);

export function createRouter(store) {
    const router = new VueRouter({
        mode: 'history',
        base: process.env.BASE_URL,
        routes,
    });

    /**
     * 可以在这里（创建路由之前）提前往 store 中准备数据
     * ! 请注意：此处只针对原始的公共参数进行操作，不会对其进行二次修改，如果需要设置默认的初始值，可以在对应页面组件中再进行配置。
     */
    const { platform, appId } = searchParams(window.location.search, 'platform', 'appId');
    if (platform) {
        sessionStorage.setItem('platform', JSON.stringify(+platform));
        store.commit('setPlatform', +platform);
    }
    if (appId) sessionStorage.setItem('appId', JSON.stringify(appId));

    // 也可以写异步请求（提前配置 favicon、document.title，获取三方 OAuth 配置信息）
    const platforms = [Platform.H5, Platform.Iframe, Platform.H5Transfer, Platform.WebViewTransfer];
    const currentAppId = appId || jsonParser(sessionStorage.getItem('appId'));
    const currentplatform = +platform || jsonParser(sessionStorage.getItem('platform'));

    if (currentAppId && platforms.includes(currentplatform)) {
        // iframe 过渡页面无需请求（后期需要优化区分）
        if (window.location.pathname !== '/iframe') {
            store.dispatch('queryBasicInitialization').then(() => {
                const { webTagBrandLogoUrl, brandName } = store.state.brandInfo;
                setLinkFavicon(webTagBrandLogoUrl);
                document.title = brandName;
            });
        }
    }

    router.beforeEach((to, from, next) => {
        if (to.name === 'Login' || sessionStorage.getItem('Authorization')) {
            next();
        } else {
            next();
            // router.push({ path: '/login' });
        }
    });

    router.afterEach(() => {
        window.scrollTo(0, 0);
    });

    return router;
}

export default createRouter;
